<template>

<div>

  <LDBsTable
    url="vehiclebrands"
    defaultSort="name"
    defaultOrder="asc"
    :query="query"
    :columns="columns"
    :clear="clear"
    :defaultOptions='options'
  >
    <div class="form-group col-12">
      <label>{{ $t('brand') }}</label>
      <input
        type="text"
        name="brand"
        class="form-control"
        v-model="query.name"
        :placeholder="$t('ph_brand')"
      >
    </div>
  </LDBsTable>

</div>

</template>

<script>
import LDBsTable from '@/components/shared/LDBsTable'

export default {
  name: 'VehicleBrandList',
  components: {
    LDBsTable
  },
  data () {
    return {
      columns: [
        {
          title: this.$t('brand'),
          field: 'name',
          sortable: true
        },
        {
          key: 'id',
          field: 'id',
          align: 'center',
          width: '100%',
          formatter: function (value) {
            return `<a href="#/main/vehiclebrands/${value}" class="edit btn btn-action btn-primary btn-circle light-bottom-shadow text-white"><i class="fas fa-pen"></i></a>`
          },
        }
      ],
      options: {
        exportOptions: { fileName: 'marcas_veiculo' }
      },
      query: {
        id: '',
        name: ''
      }
    }
  },
  methods: {
    clear() {
      this.query.name = ''
    }
  }
}

</script>